import { Module } from "@/constants";
import { useStoreProjectAssigneeId } from "@/modules/storeProjectAssignees/hooks/useStoreProjectAssigneeId";
import { StoreProjectAssigneesService } from "@/services/storeProjectAssignees";
import { useQuery } from "@tanstack/react-query";

export const useStoreProjectAssignee = (enabled = true) => {
  const assigneeId = useStoreProjectAssigneeId();
  return useQuery({
    queryKey: [Module.StoreProjectAssignees, assigneeId],
    queryFn: () => StoreProjectAssigneesService.getById(assigneeId),
    enabled,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
  });
};
